import controller from './dashboard-block.controller';
import template from './dashboard-block.html';

import './dashboard-block.scss';

export default {
	template,
	controller,
	bindings: {
		dashboard: '<',
		widgetId: '<',
		isOpen: '=?',
	},
};
